import styledEngine from "@mui/styled-engine";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popup from "ui/Popup/Popup";
import calcul_mensualite_max, {
  calcul_budget,
} from "utils/CreditImmobilier/calcul_budget";
import Info from "../../../../components/v3/Estimation/icons/Info";
import {
  actions as BudgetActions,
  selectors as BudgetSelectors,
} from "../../../../redux/slices/v2/CalculezBudget";
import CustomInput from "../../../../ui/CustomInput/Input";
import CustomSelect from "../../../../ui/CustomSelect/CustomSelect";
import style from "./RevenuMensuel.module.css";

function RevenuMensuel({ t }: { t: any }) {
  const [clicked, setClicked] = useState(false);

  const RevenuSimple = useSelector(BudgetSelectors.revenuSimpleSelector);

  const RevenuAvance = useSelector(BudgetSelectors.revenuAvanceSelector);

  const Budget = useSelector(BudgetSelectors.budgetSelector);
  const MensualiteMax = useSelector(BudgetSelectors.MensualiteMaxSelector);
  const MensualiteChoisi = useSelector(
    BudgetSelectors.MensualiteChoisiSelector
  );
  const dispatch = useDispatch();

  const [revenuData, setRevenuData] = useState({
    Budget: Budget,
    Simple: {
      detteMensuel: RevenuSimple.detteMensuel,
      salaireMensuel: RevenuSimple.salaireMensuel,
      Acompte: RevenuSimple.Acompte,
    },
    Avance: {
      tauxInt: RevenuAvance.tauxInt,
      Programme: RevenuAvance.Programme,
      Capacity: RevenuAvance.Capacity,
    },
  });

  const programeDePret = [t("15 ans"), t("20 ans"), t("25 ans")];
  const programeDePret_duree = {
    "15 ans": 180,
    "20 ans": 240,
    "25 ans": 300,
  };
  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } else {
      dispatch(
        BudgetActions.setRevenuSimple({
          ...revenuData.Simple,
        })
      );

      dispatch(
        BudgetActions.setRevenuAvance({
          ...revenuData.Avance,
        })
      );

      revenuData.Simple.salaireMensuel,
        revenuData.Simple.detteMensuel,
        revenuData.Simple.Acompte,
        revenuData.Avance.tauxInt,
        programeDePret_duree[revenuData.Avance.Programme],
        revenuData.Avance.Capacity;

      calcul_mensualite_max(
        revenuData.Simple.salaireMensuel,
        revenuData.Simple.detteMensuel,
        revenuData.Simple.Acompte,
        revenuData.Avance.tauxInt,
        programeDePret_duree[revenuData.Avance.Programme],
        revenuData.Avance.Capacity
      );
      let { mensualite, budget } = calcul_mensualite_max(
        revenuData.Simple.salaireMensuel,
        revenuData.Simple.detteMensuel,
        revenuData.Simple.Acompte,
        revenuData.Avance.tauxInt,
        programeDePret_duree[revenuData.Avance.Programme],
        revenuData.Avance.Capacity
      );
      dispatch(BudgetActions.setBudget(parseInt(budget)));
      dispatch(
        BudgetActions.setMensualiteMax(
          isNaN(mensualite) ? 0 : parseInt(mensualite)
        )
      );
      dispatch(
        BudgetActions.setMensualiteChoisi(
          isNaN(mensualite) ? 0 : parseInt(mensualite)
        )
      );
    }
  }, [revenuData]);

  // update budget when mensualite choisi changes

  useEffect(() => {
    let { budget } = calcul_budget(
      MensualiteChoisi,
      revenuData.Simple.Acompte,
      revenuData.Avance.tauxInt / 100,
      programeDePret_duree[revenuData.Avance.Programme]
    );
    dispatch(BudgetActions.setBudget(parseInt(budget)));
  }, [MensualiteChoisi]);

  const [popedUp, setPopedUp] = useState(false);

  const popupText = `
                      ${t("La calculatrice hypothécaire")}`;

  return (
    <div className={style.container}>
      <div className={style.formContainer}>
        <div className={style.Revenu}>
          <p className={style.revenuMensuelTitle}>{t("Revenu mensuel")}</p>
          <label htmlFor="annuel" className={style.labelText}>
            {t("Total de vos entrées mensuelles nets d’impôts")}
          </label>
          <div className={style.formInput}>
            <CustomInput
              type={"string"}
              name={"salaireMensuel"}
              id={"annuel"}
              pattern="\d*"
              min={0}
              value={
                RevenuSimple.salaireMensuel
                  ? RevenuSimple.salaireMensuel
                      .toString()
                      .replace(/(.)(?=(\d{3})+$)/g, "$1 ")
                  : ""
              }
              styleInput={style.custumInput}
              styleLabel={style.Label}
              styleContainer={style.inputContainer}
              onChange={(e) => {
                setRevenuData({
                  ...revenuData,
                  Simple: {
                    ...revenuData.Simple,
                    salaireMensuel: parseInt(
                      e.target.value.replaceAll(" ", "")
                    ),
                  },
                });
              }}
              placeHolder={t("Ex: 15 000")}
              inputFor={t("MAD/Mois")}
              styleInputFor={style.mad}
            />
          </div>
          <label htmlFor="annuel" className={style.labelText}>
            {t("Total de vos dépenses de crédit mensuelles")}
          </label>
          <div className={style.formInput}>
            <CustomInput
              type={"string"}
              id={"mensuel"}
              pattern="\d*"
              name={"detteMensuel"}
              min={0}
              value={
                RevenuSimple.detteMensuel
                  ? RevenuSimple.detteMensuel
                      .toString()
                      .replace(/(.)(?=(\d{3})+$)/g, "$1 ")
                  : ""
              }
              styleInput={style.custumInput}
              styleLabel={style.Label}
              styleContainer={style.inputContainer}
              onChange={(e) => {
                setRevenuData({
                  ...revenuData,
                  Simple: {
                    ...revenuData.Simple,
                    detteMensuel: parseInt(e.target.value.replaceAll(" ", "")),
                  },
                });
              }}
              placeHolder={t("Ex: 2 000")}
              inputFor={t("MAD/Mois")}
              styleInputFor={style.mad}
            />
          </div>
        </div>
        <div className={style.Revenu}>
          <p className={style.AcompteTitle}>{t("Acompte")}</p>
          <div className={style.formInput}>
            <CustomInput
              type={"string"}
              id={"Acompte"}
              name={"Acompte"}
              pattern="\d*"
              min={0}
              value={
                RevenuSimple.Acompte
                  ? RevenuSimple.Acompte.toString().replace(
                      /(.)(?=(\d{3})+$)/g,
                      "$1 "
                    )
                  : ""
              }
              styleInput={style.custumInputMad}
              styleLabel={style.Label}
              styleContainer={style.inputContainer}
              onChange={(e) => {
                setRevenuData({
                  ...revenuData,
                  Simple: {
                    ...revenuData.Simple,
                    Acompte: parseInt(e.target.value.replaceAll(" ", "")),
                  },
                });
              }}
              placeHolder={"Ex: 100 000"}
              inputFor={"MAD"}
              styleInputFor={style.mad}
            />
          </div>
        </div>
        <div className={style.Revenu}>
          <button
            className={style.selectButton}
            onClick={() => {
              setClicked(!clicked);
            }}
          >
            {!clicked ? (
              <span className={style.selectButtonElement}>
                {t("Avancé")} <span className={style.arrowNotClicked}></span>
              </span>
            ) : (
              <span className={style.selectButtonElement}>
                {t("Simple")} <span className={style.arrowClicked}></span>
              </span>
            )}
          </button>
          {clicked ? (
            <>
              <div className={style.formInputAvance}>
                <label htmlFor="Taux">{t("Taux d'intérêt")}</label>
                <div className={style.formInput}>
                  <CustomInput
                    type={"number"}
                    id={"Taux"}
                    pattern="\d*"
                    value={RevenuAvance.tauxInt || ""}
                    styleInput={style.percentInput}
                    styleLabel={style.Label}
                    styleContainer={style.inputContainer}
                    onChange={(e) => {
                      setRevenuData({
                        ...revenuData,
                        Avance: {
                          ...revenuData.Avance,
                          tauxInt: parseFloat(e.target.value),
                        },
                      });
                    }}
                    placeHolder={t("Taux d'intérêt")}
                    inputFor={"%"}
                    styleInputFor={style.percent}
                  />
                </div>
              </div>
              <div className={style.formInputAvance}>
                <label htmlFor="programeDePret">{t("Programme de prêt")}</label>
                <div className={style.formInput}>
                  <CustomSelect
                    name={"programeDePret"}
                    id={"programeDePret"}
                    styleSelect={style.custumSelect}
                    styleLabel={style.Label}
                    styleContainer={style.inputContainer}
                    defaultValue={revenuData.Avance.Programme}
                    onChange={(e) => {
                      setRevenuData({
                        ...revenuData,
                        Avance: {
                          ...revenuData.Avance,
                          Programme: e.target.value,
                        },
                      });
                    }}
                    optionsArray={programeDePret}
                  />
                </div>
              </div>
              <div className={style.formInputAvance}>
                <label htmlFor="capacity">{t("Capacité d'endettement")}</label>
                <div className={style.formInput}>
                  <CustomInput
                    type={"number"}
                    id={"capcity"}
                    pattern="\d*"
                    value={RevenuAvance.Capacity || ""}
                    styleInput={style.percentInput}
                    styleLabel={style.Label}
                    styleContainer={style.inputContainer}
                    onChange={(e) => {
                      setRevenuData({
                        ...revenuData,
                        Avance: {
                          ...revenuData.Avance,
                          Capacity: parseFloat(e.target.value),
                        },
                      });
                    }}
                    placeHolder={t("Capacité d'endettement")}
                    inputFor={"%"}
                    styleInputFor={style.percent}
                  />
                </div>
              </div>
            </>
          ) : null}
        </div>
        <div>
          <p className={style.infos}>
            {t("Limitation de responsabilité")}
            <span
              style={{ position: "relative", width: "5px", height: "20px" }}
              onMouseEnter={() => {
                setPopedUp(true);
              }}
              onMouseLeave={() => {
                setPopedUp(false);
              }}
            >
              <Info opacity={true} />
              {popedUp ? (
                <Popup
                  title={t("Limitation de responsabilité")}
                  text={popupText}
                />
              ) : null}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RevenuMensuel;
